<!-- class students list -->
<template>
  <div class="content has_breadcrumb journal-inner">
    <base-breadcrumb
      :data="[
        {
          routeName: 'locations',
          name: user.schoolName
        },
        {
          routeName: 'journal',
          name: 'Journal'
        },
        {
          name: classname
        }
      ]"
      slot="breadcrumb"
    />
    <GgPage pageType="2" title="Journal">
      <div slot="topAppBar">
        <!-- <month-switch @change="monthChange" :defaultVal="defSwitchVal" /> -->
        <search />
      </div>
      <template v-slot:left>
        <div class="mar-l-b" v-if="hasPermission('Manage journals_Create')">
          <gg-create-button @click="hoverCreateDropdown" width="126px" label="Create" />
          <div v-if="dropdownCreateSw" class="create-dropdown-ui">
            <div class="create-dropdown-list">
              <div class="create-dropdown-list-inner">
                <ul class="create-class-list">
                  <li
                    @click="toJournalCreate(item.type)"
                    v-for="(item, index) in createBtn"
                    :key="index"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="create-dropdown-bg"
              v-if="dropdownCreateSw"
              @click="dropdownCreateSw = false"
            ></div>
          </div>
        </div>
        <class-side-menu
          :classInt="classInt"
          :year="dataEnListYearIndex"
          :month="dataEnListIndex"
          :typename="typename"
          @sideJournal="sideJournal"
        />
      </template>
      <div class="journal-list-inner">
        <div class="journal-classname">
          {{ classname }}
        </div>
        <div class="main-inner" v-loading="loading">
          <div class="for-dropdown-ui month">
            <div class="for-dropdown" @click="hoverDropdown" :class="{ hover: dropdownSw }">
              {{ dataEnListIndex }}
              <img class="arrow-drop" src="@/assets/images/icons/arrow_drop.svg" />
              <div class="dropdown-list">
                <div class="dropdown-list-inner">
                  <ul class="class-list">
                    <li
                      v-for="(item, index) in dataEnList"
                      :key="index"
                      @click="_selectMonth(item)"
                      :class="{ active: dataEnListIndex === item }"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="for-dropdown-bg" v-if="dropdownSw" @click="dropdownSw = false"></div>
          </div>

          <div class="for-dropdown-ui year">
            <div class="for-dropdown" @click="hoverDropdown1" :class="{ hover: dropdownSw1 }">
              {{ dataEnListYearIndex }}
              <img class="arrow-drop" src="@/assets/images/icons/arrow_drop.svg" />
              <div class="dropdown-list">
                <div class="dropdown-list-inner">
                  <ul class="class-list">
                    <li
                      v-for="(item, index) in dataEnListYear"
                      :key="index"
                      @click="_selectYear(item)"
                      :class="{ active: dataEnListYearIndex === item }"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="for-dropdown-bg" v-if="dropdownSw1" @click="dropdownSw1 = false"></div>
          </div>

          <div
            class="journal-list-box-inner"
            v-infinite-scroll="loadJournal"
            v-if="list.length > 0"
          >
            <div
              class="journal-box"
              v-for="(item, index) in list"
              :key="index"
              :class="{ isNewsletter: isNewsletter }"
            >
              <a
                class="journal-img"
                :class="{
                  'pdf-journal-img': isPdfNewsletter(item),
                  'pdf-single-page': getPdfThumbnailImages(item).length === 1
                }"
                :href="toDetailHref(item.id, item.newsletter ? 0 : 1, item)"
                @click.left.exact.prevent="toDetail(item.id, item.newsletter ? 0 : 1, item)"
                :style="getJournalCoverStyle(item)"
              >
                <template v-if="isPdfNewsletter(item)">
                  <span class="pdf-chip">PDF</span>
                  <div class="pdf-thumbnail-pages" v-if="getPdfThumbnailImages(item).length">
                    <img
                      v-for="(image, imageIndex) in getPdfThumbnailImages(item)"
                      :key="imageIndex"
                      :src="pdfThumbPath(image)"
                    />
                  </div>
                </template>
                <el-tooltip
                  v-if="item.pdfFailed"
                  effect="dark"
                  placement="top"
                  popper-class="journal-pdf-state-tooltip journal-pdf-failure-tooltip"
                  :visible-arrow="false"
                >
                  <div slot="content">
                    The {{ item.newsletter ? 'newsletter' : 'portfolio' }}'s processing failed.
                    Please click Approve to try again.
                  </div>
                  <span
                    class="pdf-state-badge failed"
                    @click.stop.prevent
                    @auxclick.stop.prevent
                    aria-label="PDF generation failed"
                    >!</span
                  >
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.pdfGenerating"
                  effect="dark"
                  placement="top"
                  popper-class="journal-pdf-state-tooltip journal-pdf-generating-tooltip"
                  :visible-arrow="false"
                >
                  <div slot="content">
                    The {{ item.newsletter ? 'newsletter' : 'portfolio' }} is being processed. It
                    will be posted once completed.
                  </div>
                  <span
                    class="pdf-state-badge"
                    @click.stop.prevent
                    @auxclick.stop.prevent
                    aria-label="PDF generation in progress"
                  >
                    <i class="el-icon-more"></i>
                  </span>
                </el-tooltip>
              </a>
              <div class="journal-tit" :title="item.title">
                {{ item.title }}
              </div>
              <div class="journal-col">
                <gg-menu-bar>
                  <i class="iconmore_vert-24px iconfont" />
                  <template slot="menus">
                    <gg-menu-bar-item
                      v-if="
                        item.status === 'DRAFT' ||
                        item.status === 'PENDING' ||
                        item.status === 'POSTED'
                      "
                      @click="toPreview(item.id, item.newsletter ? 0 : 1, item)"
                    >
                      <span>Preview</span>
                    </gg-menu-bar-item>

                    <gg-menu-bar-item
                      v-if="item.status === 'DRAFT' && hasPermission('Share journals_Create')"
                      @click="journalSubmitShow(item.id, item.newsletter ? 0 : 1, item)"
                    >
                      <span>Submit</span>
                    </gg-menu-bar-item>

                    <gg-menu-bar-item
                      v-if="canShowJournalUndo(item)"
                      @click="journalUndoShow(item.id, item.newsletter ? 0 : 1, item)"
                    >
                      <span>Undo</span>
                    </gg-menu-bar-item>

                    <gg-menu-bar-item
                      v-if="canShowJournalApprove(item)"
                      @click="journalApproveShow(item.id, item.newsletter ? 0 : 1, item)"
                    >
                      <span>Approve</span>
                    </gg-menu-bar-item>

                    <gg-menu-bar-item
                      v-if="canShowJournalRecall(item)"
                      @click="journalRecallShow(item.id, item.newsletter ? 0 : 1, item)"
                    >
                      <span>Recall</span>
                    </gg-menu-bar-item>

                    <gg-menu-bar-item v-if="canShowJournalMenuDivider(item)" class="hr-class">
                      <hr class="hr" />
                    </gg-menu-bar-item>

                    <gg-menu-bar-item
                      v-if="canShowJournalEdit(item)"
                      @click="toEdit(item.id, item.newsletter ? 0 : 1, item)"
                    >
                      <span>Edit</span>
                    </gg-menu-bar-item>

                    <gg-menu-bar-item
                      v-if="canShowJournalDelete(item)"
                      @click="journalDeleteShow(item.id, item.newsletter ? 0 : 1, item)"
                    >
                      <span>Delete</span>
                    </gg-menu-bar-item>
                  </template>
                </gg-menu-bar>
              </div>
            </div>
          </div>

          <div class="empty-box" slot="empty" v-else>
            <img :src="require('@/assets/images/moments/empty_photo.png')" />
            <!-- <p>No {{ $route.query.typename ? $route.query.typename.split('_')[0] : '' }} yet.</p> -->
            <p>No {{ journalListType }} yet.</p>
          </div>
        </div>
      </div>

      <Snackbar :visible.sync="loadingShow" :content="loadingText" />

      <gg-Dialog
        width="580px"
        :visible.sync="journalDeleteSw"
        :title="'Delete ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once deleted, you will not be able to recover the
          {{ journalType === 0 ? 'newsletter' : 'portfolio' }} data.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalDeleteSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalDelete">Delete</gg-submit-button>
        </span>
      </gg-Dialog>

      <gg-Dialog
        width="580px"
        :visible.sync="journalSubmitSw"
        :title="'Submit ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once submitted, the
          {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will be subjected to approval for
          sharing.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalSubmitSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalSubmit">Submit</gg-submit-button>
        </span>
      </gg-Dialog>

      <gg-Dialog
        width="580px"
        :visible.sync="journalUndoSw"
        :title="'Undo submission?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once undone, the
          {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will change from pending to draft.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalUndoSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalUndo">Undo</gg-submit-button>
        </span>
      </gg-Dialog>

      <gg-Dialog
        width="580px"
        :visible.sync="journalApproveSw"
        :title="'Approve ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once approved, the
          {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will be shared and viewed by parents.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalApproveSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalApprove">Approve</gg-submit-button>
        </span>
      </gg-Dialog>

      <gg-Dialog
        width="580px"
        :visible.sync="journalRecallSw"
        :title="'Recall ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once recalled, the
          {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will change from posted to draft and
          not be seen by parents.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalRecallSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalRecall">Recall</gg-submit-button>
        </span>
      </gg-Dialog>

      <select-user-popup
        @close="selectUsershow()"
        :selectUserSw="selectUsersp"
        :classId="classid"
      />
    </GgPage>
  </div>
</template>

<script>
import moment from 'moment'
import { Ajax } from '@/common'
import { ossThumbUrl } from '@/common/ossImage'
import { routeHref } from '@/common/nav-state'
import { mapState } from 'vuex'
import selectUserPopup from './../modules/selectUserPopup'
import classSideMenu from './../modules/classSideMenu'
import search from './../modules/search'
import pdfListState, { pdfEditable } from './../utils/pdf-list-state'
import { hasPermission } from './../utils/utils.js'
export default {
  mixins: [pdfListState],
  components: { classSideMenu, selectUserPopup, search },
  computed: {
    ...mapState({
      user: (state) => state.user
    }),
    // 列表状态的 URL 种子（typename + month/listYear）：合一 watch，同次导航多键齐变也只触发一次
    _listStateSeed() {
      return `${this.$route.query.typename || ''}|${this.$route.query.month || 'All'}|${
        this.$route.query.listYear || 'All'
      }`
    }
  },
  data() {
    return {
      journalListType: 'newsletter',
      pages: 0,
      pageNum: 1,
      classInt: '',
      month: '',
      year: '',
      journalType: 0,
      journalIndex: '',
      journalRecallSw: false,
      journalApproveSw: false,
      journalUndoSw: false,
      journalSubmitSw: false,
      journalDeleteSw: false,
      typename: '',
      classid: '',
      selectUsersp: false,
      createBtn: [
        {
          name: 'Create a newsletter',
          type: 0
        },
        {
          name: 'Create a portfolio',
          type: 1
        }
      ],
      loadBtn: false,
      loadingText: '',
      loadingShow: false,
      dropdownCreateSw: false,
      dropdownSw1: false,
      dropdownSw: false,
      loading: false,
      classname: '',
      defSwitchVal: 0,
      createTypeName: ['newsletter', 'portfolio'],
      date: this.$route.query.time ? moment(parseInt(this.$route.query.time)) : moment(),
      list: [],
      dataEnListIndex: 'All',
      dataEnListYearIndex: 'All',
      monthArr: {
        All: '',
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      },
      dataEnListYear: ['All'],
      dataEnList: [
        'All',
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      isNewsletter: true,
      status: '',
      // 最后应用（播种并取数）的列表状态键：侧栏 echo 与外部路由变化按此去重，一次导航一次取数
      appliedListStateKey: ''
    }
  },
  created() {
    // this.initMonthSwitchVal()
    // 守卫先行：缺路由 id 不发起任何取数（同 classes/classDetail 口径）
    if (!this._guardRouteIdentity()) return
    this._seedClassContext()
    this._seedListSelections()
  },
  watch: {
    // A→B 组件复用（back/forward）：按新身份重播种上下文、清旧行/选择/弹窗、重取
    // （列表响应由 pdfListState 的 requestSeq/epoch 栅栏按请求身份丢弃，身份切换即作废）
    '$route.params.id'() {
      if (!this._guardRouteIdentity()) return
      this._seedClassContext()
      this._resetClassViewState()
      // 侧栏计数归属旧班级：classInt 是 classSideMenu 的刷新触发器（读当前路由身份）
      this.classInt = this.classid + moment().valueOf()
      // 下拉选择随新身份的 URL 重播种（_resetClassViewState 清 'All' 后按 query 回种）
      this._seedListSelections()
      this.getJournal()
      this.appliedListStateKey = this._listStateKey()
    },
    // 列表状态（typename + month/listYear）URL 驱动（back/forward/深链外部变化）：按路由值播种
    // enum 三态（typename/isNewsletter/status）与下拉选择并单次重取。去重键等于最后应用状态
    // （sideJournal/_selectMonth/_selectYear 写端已先行播种并取数）或身份切换在途
    // （'$route.params.id' watcher 全权处理）时不重复取
    _listStateSeed() {
      if (this.$route.params.id !== this.classid) return
      if (!this._guardRouteIdentity()) return
      const state = this._listStateFromRoute()
      const selections = this._listSelectionsFromRoute()
      const stateKey = `${this.$route.params.id}|${state.typename}|${selections.month}|${selections.year}`
      if (stateKey === this.appliedListStateKey) return
      this.typename = state.typename
      this.isNewsletter = state.isNewsletter
      this.status = state.status
      this.dataEnListIndex = selections.month
      this.dataEnListYearIndex = selections.year
      this.getJournal()
      this.appliedListStateKey = stateKey
    }
  },
  methods: {
    moment,

    hasPermission,

    // 缺路由 id（缺失/空串）提示并回列表；created 与身份切换共用
    _guardRouteIdentity() {
      if (!this.$route.params.id) {
        this.$message.error('Missing class')
        this.$router.replace('/journal')
        return false
      }
      return true
    },

    // 身份上下文播种（created 与 A→B 复用共用）：classid/classname/typename/year 全部来自路由
    _seedClassContext() {
      this.classname = this.$route.query.className || this.$route.query.classname || ''
      this.classid = this.$route.params.id || ''

      // 列表三态同源播种（created 与 A→B 复用共用）：全枚举 typename ↔ newsletter bool +
      // status 短值，与 classSideMenu.menuSelect 同款映射
      const state = this._listStateFromRoute()
      this.typename = state.typename
      this.isNewsletter = state.isNewsletter
      this.status = state.status
      let year = this.$route.query.year || '',
        thisyear = moment().year().toString()
      this.dataEnListYear = ['All']
      this.dataEnListYear.push(year)
      let count
      if (year != thisyear) {
        count = thisyear - year
        if (count > 1) {
          for (let c = 1; c < count; c++) {
            this.dataEnListYear.push(Number(year) + c)
          }
        }
        this.dataEnListYear.push(thisyear)
      }
    },

    // 下拉选择读端（month/listYear）：缺键/空串/垃圾值回 'All'；命中回选项原项
    // （dataEnListYear 含数字项，保 active 高亮与 getJournal/classSideMenu 传参同口径）
    _listSelectionsFromRoute() {
      const monthKey = this.$route.query.month
      const yearKey = this.$route.query.listYear
      return {
        month: (monthKey && this.dataEnList.find((o) => String(o) === String(monthKey))) || 'All',
        year: (yearKey && this.dataEnListYear.find((o) => String(o) === String(yearKey))) || 'All'
      }
    },

    // 下拉选择随 URL 播种（created、A→B 复用与外部路由变化共用）：
    // 'All' 写端省键、读端缺键回 'All'（不引入 'all' 哨兵——那是 location 型筛选口径）
    _seedListSelections() {
      const selections = this._listSelectionsFromRoute()
      this.dataEnListIndex = selections.month
      this.dataEnListYearIndex = selections.year
    },

    // 缺省 typename（无 query.typename 深链）的权限默认（原 _seedClassContext 内联口径）
    _defaultTypename() {
      if (
        (this.hasPermission('Manage journals_View') && this.hasPermission('Share journals_View')) ||
        this.hasPermission('Manage journals_View')
      ) {
        return 'newsletter_draft'
      }
      return 'newsletter_posted'
    },

    // 路由 typename 全枚举 → 列表三态（与 classSideMenu.menuSelect 同款映射：
    // split('_')[0] ↔ newsletter bool、split('_')[1].toUpperCase() ↔ status 短值）
    _listStateFromRoute() {
      const typename = this.$route.query.typename || this._defaultTypename()
      const [kind, short] = typename.split('_')
      return {
        typename,
        isNewsletter: kind === 'newsletter',
        status: (short || '').toUpperCase()
      }
    },

    // 最后应用列表状态的去重键（身份 + typename 全枚举 + 下拉选择）：getJournal 参数的 1:1 投影
    _listStateKey() {
      return `${this.classid}|${this.typename}|${this.dataEnListIndex}|${this.dataEnListYearIndex}`
    },

    // A→B 复用时清掉归属旧班级的行/行操作目标/筛选选择/弹窗：确认与写操作不得跨身份触发
    _resetClassViewState() {
      this.list = []
      this.pdfListMutations = {}
      this.pages = 0
      this.pageNum = 1
      this.dataEnListIndex = 'All'
      this.dataEnListYearIndex = 'All'
      this.journalIndex = ''
      this.journalType = 0
      this.journalRecallSw = false
      this.journalApproveSw = false
      this.journalUndoSw = false
      this.journalSubmitSw = false
      this.journalDeleteSw = false
      this.selectUsersp = false
      this.dropdownCreateSw = false
      this.dropdownSw = false
      this.dropdownSw1 = false
      this.loadBtn = false
      this.loadingShow = false
      this.loadingText = ''
    },

    dateDiff(date) {
      let a = moment.utc(date),
        b = moment()
      return a.diff(b, 'days')
    },

    momentTime(date) {
      return moment.utc(date).local().format('DD/MM/YYYY, hh:mm A')
    },

    sideJournal(newsletter, status, typename) {
      // 去重（一次导航一次取数）：侧栏 echo（classSideMenu 的 typename prop watcher / 初始 int()
      // emit）携带的正是最后应用状态时，不再 replace、不再重取
      const stateKey = `${this.classid}|${typename}|${this.dataEnListIndex}|${this.dataEnListYearIndex}`
      if (stateKey === this.appliedListStateKey) return
      // 克隆 query（原地改会触发 vue-router NavigationDuplicated）；写完整 enum（'newsletter_draft' 形态，
      // 而非 status 短值 'DRAFT'——classSideMenu.menuSelect 的 split('_')[1] 依赖完整形态）
      let query = { ...this.$route.query, typename }

      // 与现 query 全等不发起 replace（NavigationDuplicated 触发面，同 _replaceListSelectionQuery）
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({
          query: query
        })
      }

      this.isNewsletter = newsletter
      this.typename = typename
      this.status = status
      this.pages = 0
      this.pageNum = 1
      this.getJournal()
      this.appliedListStateKey = stateKey
    },

    // 下拉选择写端（month/listYear）：内存 + URL 克隆 query replace（sideJournal 同款）+ 按新选择单次重取
    _selectMonth(item) {
      const changed = item !== this.dataEnListIndex
      this.dataEnListIndex = item
      this._replaceListSelectionQuery('month', item)
      if (changed) this.getJournal()
      this.appliedListStateKey = this._listStateKey()
    },

    _selectYear(item) {
      const changed = item !== this.dataEnListYearIndex
      this.dataEnListYearIndex = item
      this._replaceListSelectionQuery('listYear', item)
      if (changed) this.getJournal()
      this.appliedListStateKey = this._listStateKey()
    },

    // 克隆 query 只改一键后 replace；'All' 省键（读端缺键回 'All'）；
    // 与现 query 全等不发起（NavigationDuplicated 触发面）
    _replaceListSelectionQuery(key, value) {
      const query = { ...this.$route.query }
      if (value === 'All') delete query[key]
      else query[key] = value
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query })
      }
    },

    loadJournal() {
      if (this.pageNum < this.pages && !this.loading) {
        this.getJournal(true)
      }
    },

    isPdfNewsletter(item) {
      return Boolean(
        item &&
        (item.isPdf === true ||
          item.pdfNewsletter === true ||
          item.isPdfNewsletter === true ||
          item.pdfFilePath ||
          (Array.isArray(item.pdfImages) && item.pdfImages.length) ||
          (Array.isArray(item.pdfThumbnailImages) && item.pdfThumbnailImages.length) ||
          (Array.isArray(item.imagePaths) && item.imagePaths.length))
      )
    },

    getPdfThumbnailImages(item) {
      if (!item) return []
      const images = item.pdfThumbnailImages || item.pdfImages || item.imagePaths || []

      if (!Array.isArray(images)) return []
      return images.filter(Boolean).slice(0, 2)
    },

    normalizePdfImagePath(path) {
      if (!path) return ''
      if (/^https?:\/\//i.test(path)) return path
      return `${process.env.VUE_APP_fileBasePath}${path}`
    },

    // 列表卡片 PDF 预览图：按卡片显示框等比缩小（object-fit 场景 → mfit 取样充足）；
    // 详情/PDF 链路仍用 normalizePdfImagePath 原图
    pdfThumbPath(image) {
      return ossThumbUrl(this.normalizePdfImagePath(image), 328, 334, 'mfit')
    },

    getJournalCoverStyle(item) {
      if (this.isPdfNewsletter(item) && this.getPdfThumbnailImages(item).length) {
        return {}
      }

      if (!item || !item.cover) {
        return {}
      }

      return {
        // background-size:cover → mfit 取样充足，浏览器仍按原 CSS 裁切/定位
        backgroundImage: `url(${ossThumbUrl(item.cover, 328, 334, 'mfit')})`
      }
    },

    canShowJournalEdit(item) {
      return Boolean(
        item &&
        (item.status === 'DRAFT' || item.status === 'PENDING') &&
        pdfEditable(item) &&
        !this.isPdfNewsletter(item) &&
        this.hasPermission('Manage journals_Edit')
      )
    },

    canShowJournalMenuDivider(item) {
      return Boolean(
        item &&
        (item.status === 'DRAFT' || item.status === 'PENDING') &&
        (this.canShowJournalEdit(item) || this.canShowJournalDelete(item))
      )
    },

    getJournal(s) {
      this.journalListType = this.isNewsletter ? 'newsletter' : 'portfolio'

      let data = {
        newsletter: this.isNewsletter,
        classId: this.$route.params.id,
        status: this.status,
        staffId: this.user.userId,
        year: this.dataEnListYearIndex === 'All' ? '' : this.dataEnListYearIndex,
        month: this.dataEnListIndex === 'All' ? '' : this.monthArr[this.dataEnListIndex],
        pageSize: 12
      }

      return this.fetchPdfJournalList(data, s)
    },

    selectUsershow() {
      this.selectUsersp = false
    },

    toJournalCreate(type) {
      if (type === 0) {
        this.$router.push({
          path: '/journal/templates',
          query: {
            type: type,
            // classname: this.classname,
            classid: this.classid,
            className: this.classname,
            classId: this.classid,
            year: this.$route.query.year || ''
          }
        })
        // this.$router.push({ name: 'journalCreate', query: { type: type, classname: this.classname, classid: this.classid, time: this.moment().valueOf() }})
      }
      if (type === 1) {
        this.selectUsersp = true
        this.dropdownCreateSw = false
      }
    },

    toPreview(id, type) {
      let data = {
        id: id
      }
      Ajax.get('journal/' + id, data).then((res) => {
        if (res.code === '0000') {
          let url = this.$router.resolve({
            path:
              '/journal/view?id=' +
              encodeURIComponent(res.data.id || id) +
              '&type=' +
              this.createTypeName[type]
          })
          let win = window.open(url.href, '_blank')
          win.onload = function () {
            setTimeout(function () {
              win.document.title = 'Preview'
            }, 100)
          }
        }
      })
    },

    // 单一来源：toDetail(push) 与 toDetailHref(中键/复制链接) 共用同一 location
    _detailRoute(id, type, item) {
      return {
        name: 'journalDraft',
        query: {
          id: id,
          name: item.title,
          type: type,
          classid: this.$route.params.id,
          className: this.classname,
          classId: this.$route.params.id,
          year: this.$route.query.year || ''
        }
      }
    },
    toDetail(id, type, item) {
      this.$router.push(this._detailRoute(id, type, item))
    },
    // 防御式：走 routeHref，resolve 缺失/返回 undefined 都安全
    toDetailHref(id, type, item) {
      return routeHref(this.$router, this._detailRoute(id, type, item))
    },

    toEdit(id, type, item) {
      this.$router.push({
        name: 'journalCreate',
        query: {
          editid: id,
          type: type,
          classname: this.classname,
          classid: this.classid,
          // 与 toDetail 同形补 R32 标签 + year（C1）：编辑器面包屑 year 不再空、保存回跳不再丢 year
          className: this.classname,
          classId: this.classid,
          year: this.$route.query.year || '',
          time: this.moment().valueOf()
        }
      })
    },

    journalRecall() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      this.journalRecallSw = false
      this.loading = true
      Ajax.put('/journal/' + this.journalIndex + '/recall?staffId=' + this.user.userId)
        .then((res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been recalled'
            this.classInt = this.journalIndex + moment().valueOf()
            this.typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_draft'
            this.removeNote(this.journalIndex)
            this.loadBtn = false
          } else {
            this.loading = false
            this.loadBtn = false
          }
        })
        .catch(() => {
          this.loading = false
          this.loadBtn = false
        })
    },

    removeNote(id) {
      let data = {
        id: id
      }
      Ajax.get('journal/' + id, data).then((res) => {
        if (res.code === '0000') {
          let content = JSON.parse(res.data.content)
          for (let item of content) {
            item.note = ''
          }

          // 写载荷以 fetched journalData 为底（C1）：filePath/journalTemplateId/isPdf/pdfImages 等
          // 既有字段保留——部分字段载荷在整实体覆盖语义下会抹掉已生成 PDF 路径；
          // 变更字段在底之上覆盖，写身份维持当前用户（R18）
          let data = { ...res.data }
          data.content = JSON.stringify(content)
          data.isNewsletter = res.data.newsletter
          data.staffId = this.user.userId
          data.isSubmit = false

          Ajax.put('/journal/' + id, data).then((res) => {
            if (res.code === '0000') {
            }
          })
        }
      })
    },

    journalRecallShow(id, type, item) {
      this.journalRecallSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalApprove() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      this.journalApproveSw = false
      this.loading = true
      Ajax.put(
        '/journal/' +
          this.journalIndex +
          '/process?approve=' +
          true +
          '&staffId=' +
          this.user.userId
      )
        .then((res) => {
          if (res.code === '0000') {
            this.startApprovedPdf(this.journalIndex, this.journalType)
          } else {
            this.loading = false
            this.loadBtn = false
            this.showApprovalError(res)
          }
        })
        .catch((error) => {
          this.loading = false
          this.loadBtn = false
          this.showApprovalError(error)
        })
    },

    journalApproveShow(id, type, item) {
      this.journalApproveSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalUndo() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      Ajax.put('/journal/' + this.journalIndex + '/cancel?staffId=' + this.user.userId).then(
        (res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.journalUndoSw = false
            this.invalidatePdfListRow(this.journalIndex)
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been moved to draft'
            this.classInt = this.journalIndex + moment().valueOf()
            this.typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_draft'
            this.loadBtn = false
          }
        }
      )
    },

    journalUndoShow(id, type, item) {
      this.journalUndoSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalSubmit() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      this.journalSubmitSw = false
      this.loading = true
      Ajax.put('/journal/' + this.journalIndex + '/submit?staffId=' + this.user.userId)
        .then((res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been submitted'
            this.classInt = this.journalIndex + moment().valueOf()
            this.typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_pending'
            this.loadBtn = false
          } else {
            this.loading = false
            this.loadBtn = false
          }
        })
        .catch(() => {
          this.loading = false
          this.loadBtn = false
        })
    },

    journalSubmitShow(id, type, item) {
      this.journalSubmitSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalDelete() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      Ajax.delete('/journal/' + this.journalIndex + '?staffId=' + this.user.userId).then((res) => {
        if (res.code === '0000') {
          this.loadingShow = true
          this.journalDeleteSw = false
          this.loadingText =
            (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been deleted'
          this.classInt = this.journalIndex + moment().valueOf()
          this.loadBtn = false
        }
      })
    },

    journalDeleteShow(id, type) {
      this.journalDeleteSw = true
      this.journalIndex = id
      this.journalType = type
    },

    hoverDropdown() {
      this.dropdownSw = !this.dropdownSw
    },

    hoverDropdown1() {
      this.dropdownSw1 = !this.dropdownSw1
    },

    hoverCreateDropdown() {
      this.dropdownCreateSw = !this.dropdownCreateSw
    }

    // initMonthSwitchVal(){
    //   var _def = moment()
    //   if(this.$route.query.time && this.$route.query.time.length == 13){
    //     _def = moment(parseInt(this.$route.query.time))
    //   }
    //   this.date = _def
    //   this.defSwitchVal = _def
    //   this.year = _def.format('YYYY')
    //   this.month = _def.format('M')
    // },

    // monthChange(val){
    //   this.date = val
    //   this.year = moment(val).format('YYYY')
    //   this.month = moment(val).format('M')

    //   if(this.date>new Date().getTime()){
    //     this.list = []
    //     return
    //   }

    //   this.getJournal()
    // }
  }
}
</script>
<style>
/* Element UI appends the tooltip to body; it cannot use scoped selectors. */
.journal-pdf-state-tooltip.el-tooltip__popper.is-dark {
  box-sizing: border-box;
  padding: 6px 10px;
  border: 0;
  border-radius: 2px;
  background: #5f6368;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  box-shadow: none;
}
.journal-pdf-generating-tooltip {
  width: 270px;
}
.journal-pdf-failure-tooltip {
  width: 236px;
}
</style>
<style lang="less" scoped>
//@import url(); 引入公共css类
.ggPage {
  /deep/.base-list .title {
    font-family: 'opensans-semibold';
    color: #5f6368;
  }
}
/deep/ .ggPage-main-center .base-list {
  padding-bottom: 112px !important;
  .title {
    font-family: 'opensans-semibold';
    margin-left: 0;
    padding-left: 10px;
  }
  .main-column {
    font-family: 'opensans-semibold';
  }
  .main-column {
    .icon {
      border-radius: 50%;
    }
  }
  ul li {
    border-top: 0 none;
    border-bottom: 1px solid #e0e0e0;
    &:nth-child(2) {
      border-bottom: 1px solid #e0e0e0;
    }
    // &:nth-last-child(1) {
    //   border-bottom: 2px solid #e0e0e0;
    // }
  }
}

.mar-l-b {
  position: relative;
}

.create-dropdown-ui {
  position: absolute;
  left: 140px;
  top: 0;
  width: 152px;

  .create-dropdown-bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 101;
    overflow: hidden;
  }

  .create-dropdown-list {
    position: relative;
    z-index: 102;
    width: 152px;
    background: #fff;
    box-shadow: 0px 3px 3px #0000004d;
    border-radius: 4px;

    .create-dropdown-list-inner {
      padding: 8px 0;

      .create-class-list {
        padding: 0;

        li {
          padding-left: 15px;
          cursor: pointer;
          text-align: left;
          line-height: 32px;
          font-size: 14px;
          font-family: Roboto;

          &.active,
          &:hover {
            background-color: #eee;
          }
        }
      }
    }
  }
}

.for-dropdown-ui {
  display: inline-block;
  margin: 20px 10px 0 0;
  width: 120px;
  height: 36px;

  .for-dropdown-bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    overflow: hidden;
  }

  .for-dropdown {
    position: relative;
    z-index: 100;
    padding: 0 16px;
    height: 36px;
    line-height: 36px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 14px;
    color: #202124;
    cursor: pointer;

    &.hover {
      .dropdown-list {
        display: block;
      }
    }

    .arrow-drop {
      position: absolute;
      right: 4px;
      top: 7px;
      width: 20px;
      height: 20px;
    }

    .dropdown-list {
      display: none;
      position: absolute;
      left: 0;
      top: 35px;
      padding: 0 2px 0 0;
      width: 119px;
      background: #fff;
      box-shadow: 0px 3px 3px #0000004d;
      border-radius: 4px;

      .dropdown-list-inner {
        padding: 8px 0;
        max-height: 176px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 4px;
          border-radius: 4px;
        }

        &::-webkit-scrollbar-track {
          background-color: #fff;
        }

        .select-all {
          padding-left: 16px;
          line-height: 28px;
          font-size: 14px;
          color: #202124;

          .el-checkbox {
            width: 100%;
            color: #202124;
          }

          &:hover {
            background-color: #eee;
          }
        }

        .class-list {
          padding: 0;

          li {
            padding-left: 16px;
            line-height: 32px;
            font-size: 14px;
            font-family: Roboto;

            .el-checkbox {
              width: 100%;
            }

            &.active,
            &:hover {
              background-color: #eee;
            }
          }
        }
      }
    }
  }
}

.journal-list-inner {
  margin-right: 150px;
}

.journal-classname {
  padding: 0 10px 25px 10px;
  line-height: 80px;
  border-bottom: 1px solid #e0e0e0;
  color: #202124;
  font: normal normal 600 22px/30px Open Sans;
}

.journal-list-box-inner {
  position: relative;
  overflow: hidden;
  padding: 20px 0 112px 0;
  margin-bottom: 92px;
  margin-right: -46px;

  .journal-box {
    float: left;
    position: relative;
    margin: 0 24px 24px 0;
    width: 328px;
    height: 200px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;

    .journal-col {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }

    .journal-tit {
      margin: 0 20px;
      width: 256px;
      line-height: 64px;
      font-size: 16px;
      text-align: left;
      font-family: Roboto;
      color: #202124;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .pdf-state-badge {
      position: absolute;
      right: 8px;
      top: 8px;
      z-index: 3;
      width: 24px;
      height: 24px;
      border-radius: 100%;
      background: #e5493d;
      color: #fff;
      line-height: 24px;
      text-align: center;

      i {
        font-size: 16px;
        vertical-align: middle;
      }

      &.failed {
        font-family: Roboto, sans-serif;
        font-weight: bold;
        font-size: 20px;
        cursor: default;
      }
    }

    .journal-img {
      display: block;
      position: relative;
      width: 100%;
      height: 136px;
      border-radius: 8px 8px 0 0;
      background-size: cover;
      background-position: top;
      cursor: pointer;
      overflow: hidden;

      &.pdf-journal-img {
        background-color: #fff;
        background-size: cover;
        border-bottom: 1px solid #e0e0e0;

        .pdf-chip {
          position: absolute;
          top: 8px;
          right: 8px;
          z-index: 2;
          height: 22px;
          line-height: 22px;
          padding: 0 8px;
          border-radius: 11px;
          background: #1a73e8;
          color: #fff;
          font-size: 12px;
          font-family: Roboto;
        }

        .pdf-thumbnail-pages {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          gap: 18px;
          padding: 44px 0 12px;
          box-sizing: border-box;

          img {
            display: block;
            width: 100%;
            max-width: none;
            height: auto;
            min-height: 0;
            flex: 1 1 0;
            object-fit: cover;
            background: #fff;
          }
        }

        &.pdf-single-page {
          .pdf-thumbnail-pages {
            justify-content: center;
            gap: 0;
            padding: 44px 0;

            img {
              flex: 0 1 auto;
              width: 100%;
              max-height: 100%;
              height: auto;
              min-height: 0;
              object-fit: contain;
            }
          }
        }
      }
    }
    &.isNewsletter {
      width: 236px;
      height: auto;
      .journal-img {
        height: 334px;
      }
      .journal-tit {
        width: 164px;
      }
    }
  }
}

.main-inner {
  position: relative;
}
</style>
